import './pdf-viewer.scss'

import { faSearch, faSearchMinus, faSearchPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { get } from 'lodash'
import * as PDFJS from 'pdfjs-dist'
import { defineComponent } from 'vue';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';

import { PDFProgressBar } from '../../../../../apps/condition-report/src/app/pdf-overview-screen/pdf-progress-bar';
import { PDFViewerPage } from './pdf-viewer-page';
import { DISPLAY_ALERT_TOPIC } from '@skinsoft/bus/src/busTopics';

// amount added/subtracted to the zoom scale on each zoom-in/zoom-out click
const ZOOM_FACTOR = 0.05

export const PDFViewer = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sPdfProgressBar: PDFProgressBar,
        sPdfViewerPage: PDFViewerPage,
    },
    props: ['pdfFile'],
    template: require('./pdf-viewer.html'),
    data() {
        return {
            pdf: null as any,
            magnifierIcon: faSearch,
            magnifierPlusIcon: faSearchPlus,
            magnifierMinusIcon: faSearchMinus,
            crossIcon: faTimes,

            pdfData: null as any,
            zoomPageScale: 1.3,

            currentPageIndex: 1,
            displayZoomOverlay: false,
            pagesIndices: [] as number[],
            nbPdfPages: 0,
        }
    },
    methods: {
        onPDFFile(pdfData) {
            this.renderPDF(pdfData)
        },
        renderPDF(pdfData) {
            PDFJS.getDocument(pdfData).promise.then((pdf) => {
                this.nbPdfPages = pdf.numPages
                this.pdf = pdf
                for (let i = 1; i <= this.nbPdfPages; i++) {
                    this.pagesIndices.push(i);
                }
            }, (reason) => {
                // PDF loading error
                console.error(reason);
                const alertPayload = {
                    message: this.$t('pdfOverviewScreen.renderFailureAlert'),
                    variant: 'danger'
                };
                this.emitOnBus(DISPLAY_ALERT_TOPIC, alertPayload)
            });
        },
        onViewerScroll(event) {
            const scrollElement = event.target
            const scrollLimit = scrollElement.scrollWidth - scrollElement.clientWidth;
            const scrollRatio = scrollElement.scrollLeft / scrollLimit;
            this.currentPageIndex = this.clampValue(Math.floor(scrollRatio * this.nbPdfPages) + 1, 1, this.nbPdfPages)
        },
        clampValue(value, min, max) {
            return Math.max(min, Math.min(max, value))
        },
        displayZoomView() {
            this.displayZoomOverlay = true;
        },
        onZoomCrossClick() {
            this.displayZoomOverlay = false;
        },
        zoomIn() {
            this.zoomFromDelta(1)
        },
        zoomOut() {
            this.zoomFromDelta(-1);
        },
        zoomFromDelta(delta) {
            let newScale: number;
            if (delta > 0) {
                newScale = this.zoomPageScale + ZOOM_FACTOR;
            } else {
                newScale = this.zoomPageScale - ZOOM_FACTOR;
            }
            this.zoomPageScale = this.clampValue(newScale, 0, 3)
        },
    },
    watch: {
        pdfFile: {
            handler(pdfFile) {
                const reader = new FileReader();
                reader.addEventListener("load", (inputElement) => {
                    const result = get(inputElement, "srcElement.result");
                    if (result) {
                        this.pdfData = new Uint8Array(result);
                        this.onPDFFile(this.pdfData);
                    }
                })
                reader.readAsArrayBuffer(pdfFile)
            },
            immediate: true,
        },
    },
})
